import { Component, OnInit } from "@angular/core";
import {
  LoadingController,
  ModalController,
  ToastController,
} from "@ionic/angular";
import { CalendarModal, CalendarModalOptions } from "ion2-calendar";
import * as moment from "moment";
import { RA } from "src/models/sisreg";
import { AlergiasService } from "src/services/alergias.service";
import { AvaliacaoRacService } from "src/services/avaliacao-rac.service";
import { DocumentService } from "src/services/document.service";
import { GlicoseService } from "src/services/glicose.service";
import { ImcService } from "src/services/imc.service";
import { MedicamentosService } from "src/services/medicamentos.service";
import { PacientService } from "src/services/pacient.service";
import { PrescricaoService } from "src/services/prescricao.service";
import { PressaoService } from "src/services/pressao.service";
import { STATUS_RA, SisREGService } from "src/services/sisreg.service";
import { INFO_TIPO } from "src/util/data/INFO_TIPO";

@Component({
  selector: "app-todos-documentos",
  templateUrl: "./todos-documentos.component.html",
  styleUrls: ["./todos-documentos.component.scss"],
})
export class TodosDocumentosComponent implements OnInit {
  emptyState = {
    imgUrl: "/assets/imgs/bg-agendamentos-regulados.svg",
    title: "O paciente não possui registros de Agendamentos Regulados",
    text: "Essa área é dedicada à disponibilização de agendamentos provenientes do Sistema Nacional de Regulação (SISREG).",
  };

  emptyStateFiltered = {
    imgUrl: "/assets/imgs/bg-agendamentos-regulados.svg",
    title:
      "O paciente não possui registros de Agendamentos Regulados com o filtro aplicado",
    text: "Essa área é dedicada à disponibilização de agendamentos provenientes do Sistema Nacional de Regulação (SISREG) com o filtro aplicado.",
  };

  next: any;
  userFiltro: any;
  procedimentoSelecionado: any;
  caraterSelecionado: any;
  statusSelecionado: any;
  list: any = [];
  documentsList: any[] = [];
  documentsFilteredList: any = [];
  cnesData: any = [];
  cidData: any = [];
  atendimentosList: any[] = [];
  vacinas: any[] = [];

  dtInicio: any;
  dtFim: any;
  procedimentosData: any = [];
  caraterAtendimentoData: any = [];
  listaFiltros: any = [];
  cnesFilter: any;
  cidFilter: any;
  STATUS_RA_INVERTIDO: any = {};
  conteudoRevelado = false;
  filtrosSelecionados: any = [];
  INFO_TIPO_INVERTIDO: any = {};

  internacoesList: any[] = [];
  atendimentosClinicosList: any[] = [];
  examesList: any[] = [];
  medicamentosList: any[] = [];
  prescricoesList: any[] = [];
  solicitacoesReguladosList: any[] = [];
  atestadosList: any[] = [];
  glicoseList: any[] | void = [];
  imcList: any[] | void = [];
  medDeclaradosList: {
    numeroCartao: any;
    id: number;
    coMedicamento: number;
    nome: string;
    descricao: string;
  }[] = [];
  listAlergias: {
    numeroCartao: any;
    id: number;
    idAlergia: number;
    nome: string;
    tipo: number;
    outra: string;
  }[] = [];
  pressaoList: {
    numeroCartao: any;
    id: number;
    dataExame: string;
    paMax: number;
    paMin: number;
  }[] = [];

  constructor(
    private loadingCtrl: LoadingController,
    private modalCtrl: ModalController,
    private toastController: ToastController,
    private sisREGService: SisREGService,
    private pacient: PacientService,
    private racService: AvaliacaoRacService,
    private prescricaoService: PrescricaoService,
    private documentService: DocumentService,
    private glicoseService: GlicoseService,
    private imcService: ImcService,
    private medicamentosService: MedicamentosService,
    private pressaoService: PressaoService,
    private alergiaService: AlergiasService,
    private document: DocumentService
  ) { }

  async ngOnInit() {
    await this.loadData();

    this.listaFiltros = Object.values(INFO_TIPO).map((termo) => termo);
  }

  labelData(date) {
    return new Date(date).toLocaleDateString("pt-BR");
  }

  invertDate(date: string) {
    return date.split("-").reverse().join("-");
  }

  resultVacina(element) {
    if (element.definition) {
      element.fullName = element.definition.parameter.find(
        (item) => item.name === "definition"
      );
    }

    return {
      id: element.id,
      nome: element.nome,
      code: element.fab,
      definitionName: element.fullName.valueString,
      doses: [
        {
          id: element.id,
          result: element.result,
          data: element.data,
          code: element.fab,
        },
      ],
    };
  }

  async formatVacina(vacinas) {
    let result = [];
    for (const element of vacinas) {
      if (element.definition) {
        element.fullName = element.definition.parameter.find(
          (item) => item.name === "definition"
        );
      }

      if (result.length > 0) {
        let valid = false;
        result.forEach((item, index) => {
          if (element.nome == item.nome) {
            valid = true;
            result[index].doses.push({
              id: element.id,
              result: element.result,
              definition: element.definition,
              data: element.data,
              code: element.fab,
              inst: element.inst,
              definitionName: element.fullName.valueString,
            });
          }
        });
        if (!valid) {
          result.push(this.resultVacina(element));
        }
      } else {
        result.push(this.resultVacina(element));
      }
    }
    result.forEach((item, index) => {
      item.doses.forEach((element) => {
        result = this.findIndex(index, element, result);
      });
    });
    return result;
  }

  async formatarVacinas() {
    for (let vacina of this.vacinas) {
      for (let element of vacina.doses) {
        const detalhe: any = await this.documentService.getReadFullVacina(
          element.id + "/$document"
        );
        if (detalhe && detalhe.lote) {
          element.lote = detalhe.lote;
          element.estabelecimento = detalhe.estabelecimento;
          element.vacinador = detalhe.vacinador;
          element.instituicao = detalhe.instituicao;
        } else {
          // console.log("e", detalhe);
        }
      }
    }
  }

  findIndex(index, element, result) {
    if (element.code == "85" || element.code == "89") {
      let qtdFio = result.filter((data) => {
        return data.doses && data.doses.find((item) => item.code == "89");
      });
      let qtdAzt = result.filter((data) => {
        return data.doses && data.doses.find((item) => item.code == "85");
      });
      if (qtdFio.length == 1 && qtdAzt.length == 1) {
        result[index]["print"] = true;
      }
    } else if (element.code == "88") {
      result[index]["print"] = true;
    }
    return result;
  }

  async loadData() {
    let loading = await this.loadingCtrl.create({});
    await loading.present();

    // try {
    this.userFiltro = await this.pacient.getInfo();

    // --------------------------Atestados-----------------------
    // const atendimentosList = await this.racService.getList().catch((err) => {});
    // if (atendimentosList) {
    //   this.atestadosList = atendimentosList.filter(
    //     (a) => a.atestados.length > 0
    //   );
    //   console.log(this.atestadosList);
    // }
    // ----------------------Internacoes-------------------------
    let history = await this.pacient
      .getHistory(this.userFiltro, null)
      .catch((err) => { });

    if (history) {
      let list = history.docs;
      this.internacoesList = list.filter(
        (atendimento) => atendimento.tipo == "SUMÁRIO DE ALTA"
      );
      await Promise.all(
        this.internacoesList.map(async (inter) => {
          const internacaoDetalhe = await this.document.loadDetailCMD(inter);
          console.log(internacaoDetalhe);
          inter.org = internacaoDetalhe.org;
          inter.modalidade = internacaoDetalhe.modalidade;
          inter.motivo = internacaoDetalhe.motivo;
          return inter;
        })
      );
      console.log(this.internacoesList);
    }

    // ------------------Atendimentos Clinicos-----------------------

    const attClinicosList = await this.racService.getList().catch((err) => { });
    if (attClinicosList) {
      this.atendimentosClinicosList = attClinicosList;
    }
    console.log(this.atendimentosClinicosList);

    console.log("aqui");
    // ------------------------Exames----------------------------------

    const exames = await this.pacient
      .getList(null, "tests", this.userFiltro.cnsPaciente)
      .catch((err) => { });

    if (exames) {
      this.examesList = exames.docs;
    }

    console.log(this.examesList);

    // ------------------------Medicamentos----------------------------

    const medicamentos: any = await this.pacient.recuperarMedicamentosRecebidos(
      0,
      0,
      0,
      1000,
      1
    );
    this.medicamentosList = medicamentos.docs;

    console.log(this.medicamentosList);

    // ------------------------Prescrições----------------------------
    // this.prescricoesList = await this.prescricaoService.getPrescricao();

    // console.log(this.prescricoesList);

    // -----------------Solicitações Reguladas---------------------
    // this.solicitacoesReguladosList = await this.sisREGService.getList();

    // console.log(this.solicitacoesReguladosList);
    // ------------------------Vacinas-------------------------------

    let vacinas: any = await this.pacient.getListClear(
      null,
      "immunizations",
      this.userFiltro.cnsPaciente
    );
    this.vacinas = await this.formatVacina(vacinas);

    await this.formatarVacinas();

    console.log(this.vacinas);

    //---------------------------------------------------------------
    this.glicoseList = await this.glicoseService.recuperar().catch((err) => {
      console.log(err);
    });
    this.imcList = await this.imcService.recuperar().catch((err) => {
      console.log(err);
    });
    this.medDeclaradosList = await this.medicamentosService
      .recuperarMedicamentos()
      .catch((err) => {
        console.log(err);
      });
    this.pressaoList = await this.pressaoService.recuperar().catch((err) => {
      console.log(err);
    });
    this.listAlergias = await this.alergiaService
      .recuperarMinhasAlergias()
      .catch((err) => {
        console.log(err);
      });

    this.formatarConteudo();

    // if (this.documentsList) {
    //   await this.loadSelectFilters();
    // }
    // } catch (e) {
    //   console.error("error", e);
    // }

    await loading.dismiss();
  }

  ordem(lista) {
    console.log('lista', lista);

    return lista.sort((a, b) => {
      let oldDateFormatA = moment(a.dateStamp ? a.dateStamp.date : a.dtAtualizacao, "DD-MM-YYYY HH:mm")
        .local()
        .format("MM-DD-YYYY HH:mm");
      let oldDateFormatB = moment(b.dateStamp ? b.dateStamp.date : b.dtAtualizacao, "DD-MM-YYYY HH:mm")
        .local()
        .format("MM-DD-YYYY HH:mm");
      let newDateA = new Date(oldDateFormatA);
      let newDateB = new Date(oldDateFormatB);

      return Number(newDateB.getTime()) - Number(newDateA.getTime());
    });
  }

  formatarConteudo() {
    if (this.vacinas.length) {
      for (let vac of this.vacinas) {
        for (let dose of vac.doses) {
          this.documentsList.push({
            tipo: "VACINA",
            local: "-",
            nome: vac.definitionName,
            date: dose.data,
            dose: dose.result,
            fabricante: dose.inst,
            lote: dose.lote,
            vacinador: dose.vacinador,
            dateStamp: {
              date: dose.data,
            },
          });
        }
      }
    }

    if (this.solicitacoesReguladosList.length) {
      console.log(this.solicitacoesReguladosList);
      for (let sol of this.solicitacoesReguladosList) {
        this.documentsList.push({
          tipo: "SOLICITACAO REGULADA",
          nome: "Solicitações reguladas",
          dtAtualizacao: sol.execucao.data,
          status: sol.status,
          dtSolicitacao: sol.solicitacao.data,
          telefoneSolicitacao: sol.solicitacao.telefone,
          enderecoSolicitacao: sol.solicitacao.endereco,
          modalidade: sol.modalidadeAmbulatorial,
          especialidade: sol.especialidade,
          motivo: sol.motivoSolicitacao,
          estabelecimento: sol.solicitacao.nome,
          dtExecucao: sol.execucao.data,
          telefoneExecucao: sol.execucao.telefone,
          enderecoExecucao: sol.execucao.endereco,
          dateStamp: {
            date: sol.solicitacao.data,
            format: "DD/MM/YYYY",
          },
        });
      }
    }

    if (this.atendimentosClinicosList.length) {
      for (let att of this.atendimentosClinicosList) {
        this.documentsList.push(Object.assign(att, {
          tipo: "ATENDIMENTO CLÍNICO",
          nome: "Atendimento",
          dtAtualizacao: att.dtAtendimento,
          estabelecimento: att.nmEstabelecimento,
          dtSolicitacao: "-",
          telefoneSolicitacao: "-",
          enderecoSolicitacao: "-",
          modalidade: "-",
          especialidade: "-",
          motivo: "-",
          dtExecucao: att.dtAtendimento,
          telefoneExecucao: "-",
          enderecoExecucao: "-",
          dateStamp: {
            date: att.dtAtendimento,
            format: "DD/MM/YYYY",
          },
        }));
      }
    }

    if (this.internacoesList.length) {
      for (let inter of this.internacoesList) {
        this.documentsList.push(Object.assign(inter, {
          tipo: "INTERNAÇŌES",
          nome: "Internações",
          data: inter.data,
          estabelecimento: inter.org.nome,
          dtSolicitacao: inter.list.dtStart,
          telefoneSolicitacao: "-",
          enderecoSolicitacao: "-",
          modalidade: inter.modalidade,
          especialidade: inter.list.practitionerFunction,
          motivo: inter.motivo,
          dtExecucao: inter.list.dtEnd,
          telefoneExecucao: inter.org.telefone,
          enderecoExecucao: inter.org.nome,
          categoria: inter.categoria,
          cid: inter.list.reasonReference,
          cnes: inter.org.cnes,
          dateStamp: { date: inter.list.dtStart, format: "YYYY-MM-DD" },
        }));
      }
    }

    if (this.atestadosList.length) {
      for (let atestado of this.atestadosList) {
        for (let att of atestado.atestados) {
          this.documentsList.push({
            tipo: "ATESTADOS",
            nome: "Atestados",
            data: atestado.dtAtendimento,
            estabelecimento: atestado.nmEstabelecimento,
            diagnosticos: att.diagnostico,
            dtInicioAfastamento: att.dtInicioAfastamento,
            tempoAfastamento: att.tempoAfastamento,
            nomeProfissional: atestado.nmProfissional,
            numeroConselho: atestado.nmConselhoProfissional,
            ocupacao: atestado.nmCBOProfissional,
            dateStamp: { date: atestado.dtAtendimento, format: "DD/MM/YYYY" },
          });
        }
      }
    }

    if (this.prescricoesList.length) {
      for (let pres of this.prescricoesList) {
        this.documentsList.push({
          tipo: "PRESCRICOES",
          nome: "Prescrições",
          dtAtualizacao: pres.dataHoraPrescricao,
          estabelecimento: pres.nmEstabelecimento,
          dtPrescricao: pres.dataHoraPrescricao,
          profissional: pres.nmProfissional,
          crm: pres.crmProfissional,
          endereco: pres.endereco,
          medicamentos: pres.medicamentos,
          dateStamp: {
            date: pres.dataHoraPrescricao,
            format: "DD/MM/YYYY hh:mm",
          },
        });
      }
    }
    if (this.medicamentosList) {
      if (this.medicamentosList[0].medicamentos.length) {
        for (let med of this.medicamentosList[0].medicamentos) {
          this.documentsList.push({
            tipo: "MEDICAMENTOS",
            nome: "Medicamentos recebidos",
            dtAtualizacao: med.dataRetirada,
            estabelecimento: med.nomeUnidadeDispensacao,
            nomeMedicamento: med.nomeMedicamento,
            coDispersao: med.coDispensacao,
            dtDispersao: med.dataRetirada,
            uf: med.ufRetirada,
            municipio: med.municipio,
            tipoDispersao: med.tpDispensacao,
            quantidade: med.qtdDispensada,
            vlTotal: med.vlTotal,
            vlCidada: med.vlCidadao,
            vlMinstSaude: med.vlMinstSaude,
            dateStamp: {
              date: med.dataRetirada,
              format: "DD/MM/YYYY hh:mm:ss",
            },
          });
        }
      }
    }

    if (this.examesList.length) {
      for (let ex of this.examesList) {
        this.documentsList.push({
          tipo: "EXAMES",
          nome: "Exame: " + ex.nome,
          dtAtualizacao: ex.data,
          estabelecimento: "-",
          resultado: ex.result,
          nomeExame: ex.nome,
          cns: this.userFiltro.cns,
          exame: ex.nome,
          contato: "-",
          universisdade: "-",
          dateStamp: {
            date: ex.data,
          },
        });
      }
    }
    if (this.listAlergias) {
      const aux = [
        {
          tipo: "ALERGIAS",
          nome: "Alergias",
          tipoAlergia: "medicamentos",
          listaAlergia: [],
          dtAtualizacao: "-",
        },
        {
          tipo: "ALERGIAS",
          nome: "Alergias",
          tipoAlergia: "alimentos",
          listaAlergia: [],
          dtAtualizacao: "-",
        },
        {
          tipo: "ALERGIAS",
          nome: "Alergias",
          tipoAlergia: "animais",
          listaAlergia: [],
          dtAtualizacao: "-",
        },
      ];

      for (let alergia of this.listAlergias) {
        if (alergia.nome === "Outra Alergia") {
          aux[2].listaAlergia.push(alergia);
        }
        if (alergia.nome === "Outra Alergia Alimentar") {
          aux[1].listaAlergia.push(alergia);
        }
        if (alergia.nome === "Outra Alergia Medicamentosa") {
          aux[0].listaAlergia.push(alergia);
        }
      }
      for (let al of aux) {
        this.documentsList.push(al);
      }
    }

    if (this.pressaoList) {
      this.pressaoList.forEach((pressao) => {
        this.documentsList.push({
          tipo: "PRESSAO",
          nome: "Pressão",
          dtAtualizacao: pressao.dataExame,
          precaoMax: pressao.paMax,
          precaoMin: pressao.paMin,
          precaoIdeal: "-",
          dateStamp: { date: pressao.dataExame, format: "YYYY-MM-DD" },
        });
      });
    }

    if (this.glicoseList) {
      this.glicoseList.forEach((glicose) => {
        this.documentsList.push({
          tipo: "GLICOSE",
          nome: "Glicose",
          dtAtualizacao: glicose.dataExame,
          resultado: glicose.resultado,
          dateStamp: { date: glicose.dataExame, format: "YYYY-MM-DD" },
        });
      });
    }

    if (this.imcList) {
      this.imcList.forEach((imc) => {
        this.documentsList.push({
          tipo: "IMC",
          nome: "IMC",
          dtAtualizacao: imc.data,
          imc: imc.imc,
          dateStamp: { date: imc.data, format: "YYYY-MM-DD" },
        });
      });
    }

    if (this.medDeclaradosList) {
      this.medDeclaradosList.forEach((med) => {
        this.documentsList.push({
          tipo: "MEDICAMENTOS DECLARADOS",
          nome: "Medicamentos declarados",
          dtAtualizacao: "-",
          medicamentoNome: med.nome,
          observacao: med.descricao,
        });
      });
    }

    Object.assign(this.documentsFilteredList, this.documentsList);
  }

  revelarConteudo() {
    this.conteudoRevelado = true;
    Object.assign(this.documentsFilteredList, this.documentsList);
  }

  async loadSelectFilters() {
    this.documentsList.forEach((atendimento) => {
      // atendimento.procedimentos.forEach(procedimento => {
      //   if (!this.procedimentosData.find(proc => procedimento.nome === proc)) {
      //     this.procedimentosData.push(procedimento.nome)
      //   }
      // })
      // if (!this.caraterAtendimentoData.find(caraterAtendimento => atendimento.caraterAtendimento === caraterAtendimento)) {
      //   this.caraterAtendimentoData.push(atendimento.caraterAtendimento)
      // }
      // if (!this.cnesData.find(coCnes => atendimento.coCnes === coCnes)) {
      //   this.cnesData.push(atendimento.coCnes)
      // }
      // if (!this.cidData.find(diagnostico => atendimento.diagnostico === diagnostico)) {
      //   this.cidData.push(atendimento.diagnostico)
      // }
    });
  }

  async filter(datas?: any) {
    if (datas) {
      this.dtInicio = datas.dtInicio;
      this.dtFim = datas.dtFim;
    }
    this.revelarConteudo();

    if (this.dtInicio && !moment(this.dtInicio, "DD/MM/YYYY").isValid()) {
      const toast = await this.toastController.create({
        message: "Data de início invalida!",
        position: "top",
        duration: 4000,
        cssClass: "toast-error",
      });
      await toast.present();
      this.dtInicio = null;
    }
    if (this.dtFim && !moment(this.dtFim, "DD/MM/YYYY").isValid()) {
      const toast = await this.toastController.create({
        message: "Data fim invalida!",
        position: "top",
        duration: 4000,
        cssClass: "toast-error",
      });
      await toast.present();
      this.dtFim = null;
    }

    if (this.dtInicio && this.dtFim) {
      this.documentsFilteredList = this.documentsFilteredList.filter((doc) => {
        if (doc.dateStamp) {
          const dtAtendimento = moment(
            doc.dateStamp.date,
            doc.dateStamp.format
          );
          const dtInicio = moment(this.dtInicio, "DD/MM/YYYY").subtract(1, "d");
          const dtFim = moment(this.dtFim, "DD/MM/YYYY").add(1, "d");
          return dtAtendimento.isBetween(dtInicio, dtFim);
        }
        return false;
      });
    }

    if (this.cnesFilter) {
      this.documentsFilteredList = this.documentsFilteredList.filter(
        (atendimento) => {
          return atendimento.coCnes === this.cnesFilter;
        }
      );
    }

    if (this.cidFilter) {
      this.documentsFilteredList = this.documentsFilteredList.filter(
        (atendimento) => {
          return (
            atendimento.diagnostico.toLowerCase() ===
            this.cidFilter.toLowerCase()
          );
        }
      );
    }

    if (this.procedimentoSelecionado) {
      this.documentsFilteredList = this.documentsFilteredList.filter(
        (atendimento) => {
          return atendimento.procedimentos.find(
            (procedimento) =>
              procedimento.nome.toLowerCase() ===
              this.procedimentoSelecionado.toLowerCase()
          );
        }
      );
    }

    if (this.caraterSelecionado) {
      this.documentsFilteredList = this.documentsFilteredList.filter(
        (atendimento) => {
          return (
            atendimento.caraterAtendimento.toLowerCase() ===
            this.caraterSelecionado.toLowerCase()
          );
        }
      );
    }

    // if (this.statusSelecionado) {
    //   this.atendimentosListFiltered = this.atendimentosListFiltered.filter(
    //     (atendimento) => {
    //       if (!this.listaFiltro[0]) {
    //         return true;
    //       }
    //       return this.listaFiltro.includes(
    //         STATUS_RA[atendimento.status].label.toLowerCase()
    //       );
    //     }
    //   );
    // }
    if (this.filtrosSelecionados) {
      this.documentsFilteredList = this.documentsFilteredList.filter(
        (atendimento) => {
          if (!this.filtrosSelecionados[0]) {
            return true;
          }
          return this.filtrosSelecionados.includes(INFO_TIPO[atendimento.tipo]);
        }
      );
    }
  }

  select(data, nome) {
    Object.values(INFO_TIPO).map((info, index) => {
      const chavesInfoTipo = Object.keys(INFO_TIPO);
      this.INFO_TIPO_INVERTIDO[info] = chavesInfoTipo[index];
    });

    this.revelarConteudo();
    if (!this.filtrosSelecionados.includes(data)) {
      this.filtrosSelecionados.push(data);
    }
    if (nome === "statusSelecionado") {
      this.statusSelecionado = data;
    }

    console.log(this.filtrosSelecionados);
    this.filter();
  }

  abrirItem(index) {
    !this.documentsFilteredList[index].selecionado
      ? (this.documentsFilteredList[index].selecionado = true)
      : (this.documentsFilteredList[index].selecionado =
        !this.documentsFilteredList[index].selecionado);
  }

  async openCalendar(field) {
    if (!this.dtInicio || !this.dtFim) {
      const options: CalendarModalOptions = {
        id: field,
        pickMode: "single",
        title: "Selecione as datas desejadas",
        doneLabel: "",
        closeLabel: "",
        autoDone: true,
        canBackwardsSelected: true,
        step: 12,
        weekdays: ["D", "S", "T", "Q", "Q", "S", "S"],
        weekStart: 0,
      };

      const modal = await this.modalCtrl.create({
        component: CalendarModal,
        keyboardClose: true,
        cssClass: "modal-calendar",
        componentProps: { options },
      });

      modal.onDidDismiss().then((event) => {
        this[field] = moment(event.data.string, "YYYY-MM-DD").format(
          "DD/MM/YYYY"
        );
        this.filter();
        return;
      });
      return modal.present();
    } else if (this[field]) {
      this[field] = null;
      await this.filter();
      return;
    }
  }

  async limparFiltro(field, filtro?) {
    if (field === "dtFim" || field === "dtInicio") {
      this[field] = null;
    }

    if (field === "box-filter") {
      this.filtrosSelecionados = filtro;
    }

    await this.filter();
  }
}
